// Centralized application routes for kelli-book
// Phase 1: Introduce constants only. No behavior changes yet.

export const Routes = {
  // Root and top-level
  root: '/',
  login: '/login',
  downloadApp: '/download-app',
  dashboard: '/dashboard',

  // Auth
  auth: {
    magic: '/auth/magic',
  },

  // Invitations
  invitation: {
    base: '/invitation/:id',
    profile: '/invitation/:id/profile',
    consent: '/invitation/:id/consent',
    processing: '/invitation/:id/processing',
    error: '/invitation/:id/error',
    declined: '/invitation/:id/declined',

    // Static error pages (no id)
    staticError: '/invitation/error',
    staticDeclined: '/invitation/declined',
  },

  // Organizations
  organization: {
    switching: '/organization/switching/:orgId/:orgName',
  },

  // Settings
  settings: '/settings',
  demo: '/demo',

  // Activity (cross-estate booked-work log)
  activity: {
    manage: '/activity/manage',
  },

  // Sites
  sites: {
    manage: '/sites/manage',
    import: '/sites/import',
    detail: '/sites/:id',
  },

  // Labour
  labour: {
    manage: '/labour/manage',
    // Legacy routes (kept for redirects)
    itemsManage: '/labour-items/definitions/manage',
    groupsManage: '/labour-items/groups/manage',
  },

  // Users
  users: {
    manage: '/users/manage',
    detail: '/users/:userId',
    offboarding: '/users/:userId/offboarding',
  },

  // Gangs
  gangs: {
    manage: '/gangs',
  },

  // Variations
  variations: {
    manage: '/variations/manage',
  },

  // Finance (formerly Pot Approvals)
  finance: {
    pots: '/finance/pots',
    payments: '/finance/payments',
    deductions: '/finance/deductions',
    potDetail: '/finance/pots/:potId',
  },

  // Platform (internal admin)
  platform: {
    organisations: '/platform/organisations',
    organisationDetail: '/platform/organisations/:orgId',
    features: '/platform/features',
  },

  // Developer (internal tools)
  developer: {
    notifications: '/developer/notifications',
  },

  // Onboarding
  onboarding: {
    gettingStarted: '/getting-started',
  },

  // Files (top-level)
  files: {
    root: '/files',
    site: '/files/:siteId',
    folder: '/files/:siteId/folders/:folderId',
  },

  // Misc
  notFound: '*',
} as const;

// Optional path builders for dynamic segments (add more as needed in later phases)
export const routeBuilders = {
  invitation: {
    base: (id: string) => `/invitation/${id}`,
    profile: (id: string) => `/invitation/${id}/profile`,
    consent: (id: string) => `/invitation/${id}/consent`,
    processing: (id: string) => `/invitation/${id}/processing`,
    error: (id: string) => `/invitation/${id}/error`,
    declined: (id: string) => `/invitation/${id}/declined`,
  },
  organization: {
    switching: (orgId: string, orgName: string) =>
      `/organization/switching/${orgId}/${encodeURIComponent(orgName)}`,
  },
  sites: {
    detail: (id: string) => `/sites/${id}`,
  },
  users: {
    detail: (userId: string) => `/users/${userId}`,
    offboarding: (userId: string) => `/users/${userId}/offboarding`,
  },
  finance: {
    potDetail: (potId: string) => `/finance/pots/${potId}`,
  },
  platform: {
    organisationDetail: (orgId: string) => `/platform/organisations/${orgId}`,
  },
} as const;
